import React, {useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {useGetTokenQuery, useNewPasswordMutation} from "../../../slices/rootApiSlices/authApiSlice";
import {Button, Card, Col, Form, Image, Input, Row, Alert, message} from "antd";
import Title from "../../../components/Title";
import Logo from "../../../assets/octoopi_logo.png";
import {KeyOutlined, LoadingOutlined, UnlockOutlined} from "@ant-design/icons";

const Index = () => {

    const navigate = useNavigate()
    const {token} = useParams();
    const {data, isLoading, error} = useGetTokenQuery(token);
    const [newPasswordHandle] = useNewPasswordMutation()
    const [newPassword, setNewPassword] = useState("");
    const [reNewPassword, setNewRePassword] = useState("");

    const onFinish = async () => {
        const lastData = {
            email: data?.data?.email,
            newPassword: newPassword
        }
        console.log(lastData)
        try {
            const res = await newPasswordHandle(lastData).unwrap();
            console.log(res)
            navigate('/auth/sign-in')
            message.success(res?.messageTR)
        } catch (e) {
            console.log(e)
            setNewRePassword("")
            setNewRePassword("")
            message.error(e?.data?.messageTR)
        }
    }

    if (isLoading) {
        return (
            <LoadingOutlined style={{alignItems: 'center', justifyContent: 'center', flex: 1}} size="large"/>
        )
    }

    if (error) {
        return (
            <Alert
                message="Geçersiz & Yetkisiz işlem"
                description={error?.data?.messageTR}
                type="error"
                showIcon
            />
        );
    }

    if (data) {
        return (
            <Row gutter={16}>
                <Col>
                    <Card style={{width: 400, height: 'auto'}}>
                        <div style={{textAlign: "center"}}>
                            <Title title="Octoopi Twin | Şifremi Unuttum" description="Octoopi Twin Reset Password"/>
                            <Image src={Logo} preview={false} width="70px" height="70px"/>
                            <h2>Octoopi Twin Cocpit</h2>
                            <h3>Şifremi Yenile</h3>
                            <p><strong>Lütfen bilgileri doldurunuz..</strong></p>
                        </div>
                        <Form
                            name="normal_login"
                            className="login-form"
                            initialValues={{
                                remember: true,
                            }}
                            onFinish={onFinish}
                        >
                            <Form.Item
                                name="newPassword"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Yeni şifre boş bırakılamaz!',
                                    },
                                    {
                                        min: 8,
                                        message: 'Yeni şifre en az 8 karakterden oluşmalıdır!',
                                    },
                                ]}
                            >
                                <Input
                                    size="large"
                                    prefix={<KeyOutlined className="site-form-item-icon"/>}
                                    type="password"
                                    placeholder="Yeni Şifre"
                                    disabled={isLoading}
                                    name="newPassword"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                />
                            </Form.Item>
                            <Form.Item
                                name="reNewPassword"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Yeni şifre tekrarı boş bırakılamaz!',
                                    },
                                    {
                                        validator: (rule, value) => {
                                            if (value !== newPassword) {
                                                return Promise.reject('Yeni şifreler uyuşmuyor!');
                                            }
                                            return Promise.resolve();
                                        },
                                    },
                                ]}
                            >
                                <Input
                                    size="large"
                                    prefix={<KeyOutlined className="site-form-item-icon"/>}
                                    type="password"
                                    placeholder="Yeni Şifre Tekrarı"
                                    disabled={isLoading}
                                    name="reNewPassword"
                                    value={reNewPassword}
                                    onChange={(e) => setNewRePassword(e.target.value)}
                                />
                            </Form.Item>
                            <Form.Item>
                                <Button
                                    size="large"
                                    style={{marginBottom: 1, fontSize: 15, fontWeight: 500}}
                                    type="primary"
                                    htmlType="submit"
                                    className="login-form-button"
                                    block
                                    icon={<UnlockOutlined/>}
                                    disabled={isLoading || !reNewPassword || !newPassword}
                                >
                                    Şifremi Yenile
                                </Button>
                            </Form.Item>
                        </Form>
                    </Card>
                </Col>
            </Row>
        );
    }


};

export default Index;
